export enum AnalyticsPages {
  CALLS_STATS = 'callsStatistics',
}

export const AnalyticsPlaces = {
  LIST: 'CallsStatisticsList',
}
